import { useState } from 'react';
import { Info, X } from 'lucide-react';

/**
 * Toggleable instructions drawer that lives on the far-right edge of the screen.
 * Visible ONLY on desktop (lg+). Mobile layouts keep instructions inline.
 *
 * Keeps the 3-column grid (settings | capsule | controls) perfectly symmetric
 * so the breathing capsule stays dead-center on the screen.
 */
export default function ExerciseInstructionsDrawer({ children, testIdPrefix = 'exercise' }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="hidden lg:block">
      {/* Side tab button - stays glued to right edge; slides left with the drawer */}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? 'Fermer les instructions' : 'Ouvrir les instructions'}
        className="fixed top-1/2 right-0 -translate-y-1/2 z-30 bg-white/95 backdrop-blur-md border border-r-0 border-slate-300 shadow-lg rounded-l-xl pl-2 pr-2 py-5 flex flex-col items-center gap-2 hover:bg-white"
        style={{
          transform: `translate(${open ? '-20rem' : '0'}, -50%)`,
          transition: 'transform 300ms ease',
        }}
        data-testid={`${testIdPrefix}-instructions-toggle`}
      >
        {open ? (
          <X size={18} className="text-slate-700" />
        ) : (
          <Info size={18} className="text-cyan-700" />
        )}
        <span
          className="text-[10px] font-bold text-slate-700 uppercase tracking-wider"
          style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}
        >
          {open ? 'Fermer' : 'Instructions'}
        </span>
      </button>

      {/* Drawer panel */}
      <aside
        className="fixed top-0 bottom-0 right-0 w-80 bg-white/97 backdrop-blur-md border-l border-slate-300 shadow-2xl z-20 overflow-y-auto"
        style={{
          transform: open ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 300ms ease',
        }}
        data-testid={`${testIdPrefix}-instructions-drawer`}
      >
        <div className="p-5 pt-14 space-y-4">
          {children}
        </div>
      </aside>
    </div>
  );
}
